import { Typography } from "@mui/material";
import type { ReactNode } from "react";

export type Props = {
  children: ReactNode;
};

export const SectionTitle = ({ children }: Props) => (
  <Typography
    component="h2"
    fontWeight={600}
    fontSize="1.15rem"
    textTransform="uppercase"
  >
    {children}
  </Typography>
);
